"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printRunLabel = printRunLabel;
const i18n_1 = require("./i18n");
/**
 * Print-run sentence from CH-213 §2.
 * `null` is unnumbered. A number is the total only, with no grouping
 * separators (`/1000`, not `/1,000`). The per-copy form `12/99` is out of scope.
 * The UI applies `font-mono tabular-nums` to the digits.
 */
function printRunLabel(locale, printRun) {
    if (printRun === null)
        return (0, i18n_1.t)(locale, 'card.variant.unnumbered');
    return (0, i18n_1.t)(locale, 'card.variant.limited', { n: printRun });
}
//# sourceMappingURL=print-run.js.map